<div class="main-container material-content-section p-3" style="margin: auto;">
    <mat-accordion>
        <mat-expansion-panel hideToggle>
            <mat-expansion-panel-header>
                <mat-panel-title>General</mat-panel-title>
                <!-- <mat-panel-description> This is a summary of the content </mat-panel-description> -->
            </mat-expansion-panel-header>
            <div class="info-card-container">
                <div class="info-card">
                  <h4>Nombre</h4>
                  <p>LIQUIDACION FORZPA AUSTRAL TRADING SPA</p>
                </div>
                <div class="info-card">
                    <h4>Rut</h4>
                    <p>99.584.590-3</p>
                  </div>
                <div class="info-card">
                  <h4>Giro</h4>
                  <p>COMPRA, VENTA Y ALQUILER (EXCEPTO AMOBLADOS) DE INMUEBLES</p>
                </div>
                <div class="info-card">
                  <h4>Canal Entrada</h4>
                  <p>sucursal</p>
                </div>
                <div class="info-card">
                  <h4>Página Web</h4>
                  <p></p>
                </div>
                <div class="info-card">
                    <h4>Fecha</h4>
                    <p>01-04-2025</p>
                </div>
                <div class="info-card">
                    <h4>Ejecutivo Atención</h4>
                    <p>xxemail.cl</p>
                </div>
                <div class="info-card">
                    <h4>Sucursal Contratante</h4>
                    <p>Opción 1</p>
                </div>
                <div class="info-card">
                    <h4>Fecha inicio Act SII</h4>
                    <p>01-04-2025</p>
                </div>

              </div>
        </mat-expansion-panel>
        <mat-expansion-panel hideToggle>
            <mat-expansion-panel-header>
                <mat-panel-title> <mat-chip appereance="outline" class="color-tertiary status-chip mr-3">I</mat-chip>Información Sociedad</mat-panel-title>
                <!-- <mat-panel-description> This is a summary of the content </mat-panel-description> -->
            </mat-expansion-panel-header>
            <h2 class="mt-3 mb-5">Composición de la Sociedad</h2>
            <div class="info-card-container">
                <div class="card-row d-flex">
                    <mat-form-field disabled="true" appearance="outline" class="example-full-width mx-2">
                        <mat-label>Socio</mat-label>
                        <input matInput placeholder="Ex. Pizza" value="Mayra Arena">
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="example-full-width mx-2">
                        <mat-label>Rut</mat-label>
                        <input matInput placeholder="Ex. Pizza" value="1-9">
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="example-full-width mx-2">
                        <mat-label>%</mat-label>
                        <input matInput placeholder="Ex. Pizza" value="">
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="example-full-width mx-2">
                        <mat-label>FS</mat-label>
                        <input matInput placeholder="Ex. Pizza" value="">
                      </mat-form-field>
                </div>
                <div class="card-row d-flex mt-2">
                    <mat-form-field disabled="true" appearance="outline" class="example-full-width mx-2">
                        <mat-label>Socio</mat-label>
                        <input matInput placeholder="Ex. Pizza" value="Mayra Arena">
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="example-full-width mx-2">
                        <mat-label>Rut</mat-label>
                        <input matInput placeholder="Ex. Pizza" value="1-9">
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="example-full-width mx-2">
                        <mat-label>%</mat-label>
                        <input matInput placeholder="Ex. Pizza" value="">
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="example-full-width mx-2">
                        <mat-label>FS</mat-label>
                        <input matInput placeholder="Ex. Pizza" value="">
                      </mat-form-field>
                </div>
                <div class="card-row d-flex mt-2">
                    <mat-form-field disabled="true" appearance="outline" class="example-full-width mx-2">
                        <mat-label>Socio</mat-label>
                        <input matInput placeholder="Ex. Pizza" value="Mayra Arena">
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="example-full-width mx-2">
                        <mat-label>Rut</mat-label>
                        <input matInput placeholder="Ex. Pizza" value="1-9">
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="example-full-width mx-2">
                        <mat-label>%</mat-label>
                        <input matInput placeholder="Ex. Pizza" value="">
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="example-full-width mx-2">
                        <mat-label>FS</mat-label>
                        <input matInput placeholder="Ex. Pizza" value="">
                      </mat-form-field>
                </div>
            </div>
            <div>
                <h2 class="mt-5 mb-5">Informes Comerciales</h2>
                <div class="info-card-container">

                    <div class="card-row d-flex mt-2">
                        <mat-form-field disabled="true" appearance="outline" class="example-full-width mx-2">
                            <mat-label>Número</mat-label>
                            <input matInput placeholder="Ex. Pizza" value="3">
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="example-full-width mx-2">
                            <mat-label>Monto</mat-label>
                            <input matInput placeholder="Ex. Pizza" value="100.000">
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="example-full-width mx-2">
                            <mat-label>Motivo</mat-label>
                            <input matInput placeholder="Ex. Pizza" value="">
                          </mat-form-field>
                    </div>
                    <div class="card-row d-flex mt-2">
                        <mat-form-field disabled="true" appearance="outline" class="example-full-width mx-2">
                            <mat-label>Número</mat-label>
                            <input matInput placeholder="Ex. Pizza" value="3">
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="example-full-width mx-2">
                            <mat-label>Monto</mat-label>
                            <input matInput placeholder="Ex. Pizza" value="100.000">
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="example-full-width mx-2">
                            <mat-label>Motivo</mat-label>
                            <input matInput placeholder="Ex. Pizza" value="">
                          </mat-form-field>
                    </div>
                    <div class="card-row d-flex mt-2">
                        <mat-form-field disabled="true" appearance="outline" class="example-full-width mx-2">
                            <mat-label>Número</mat-label>
                            <input matInput placeholder="Ex. Pizza" value="3">
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="example-full-width mx-2">
                            <mat-label>Monto</mat-label>
                            <input matInput placeholder="Ex. Pizza" value="100.000">
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="example-full-width mx-2">
                            <mat-label>Motivo</mat-label>
                            <input matInput placeholder="Ex. Pizza" value="">
                          </mat-form-field>
                    </div>
                </div>
            </div>

            <div>
                <h2 class="mt-5 mb-5">Empresas Relacionadas</h2>
                <div class="info-card-container">

                    <div class="info-card-container d-flex mt-2">
                        <mat-form-field disabled="true" appearance="outline" class="example-full-width mx-2">
                            <mat-label>Razón Social</mat-label>
                            <input matInput placeholder="Ex. Pizza" value="Winona Riders">
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="example-full-width mx-2">
                            <mat-label>Rut</mat-label>
                            <input matInput placeholder="Ex. Pizza" value="1-9">
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="example-full-width mx-2">
                            <mat-label>%</mat-label>
                            <input matInput placeholder="Ex. Pizza" value="">
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="example-full-width mx-2">
                            <mat-label>FS</mat-label>
                            <input matInput placeholder="Ex. Pizza" value="">
                          </mat-form-field>
                        <mat-form-field disabled="true" appearance="outline" class="example-full-width mx-2">
                            <mat-label>Número</mat-label>
                            <input matInput placeholder="Ex. Pizza" value="3">
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="example-full-width mx-2">
                            <mat-label>Monto</mat-label>
                            <input matInput placeholder="Ex. Pizza" value="100.000">
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="example-full-width mx-2">
                            <mat-label>Motivo</mat-label>
                            <input matInput placeholder="Ex. Pizza" value="">
                          </mat-form-field>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel hideToggle>
          <mat-expansion-panel-header>
              <mat-panel-title>Deudores</mat-panel-title>
              <!-- <mat-panel-description> This is a summary of the content </mat-panel-description> -->
          </mat-expansion-panel-header>
          <div class="info-card-container">
              <div class="info-card">
                <h4>Cliente</h4>
                <p>LIQUIDACION FORZPA AUSTRAL TRADING SPA</p>
              </div>
              <div class="info-card">
                  <h4>Rut</h4>
                  <p>99.584.590-3</p>
                </div>
              <div class="info-card">
                <h4>Fecha</h4>
                <p>12-05-2023</p>
              </div>
              <div class="info-card">
                <h4>Canal Entrada</h4>
                <p>sucursal</p>
              </div>
          </div>

          <div class="mt-5">
            <app-dynamic-table 
              [displayedColumns]="deudoresDisplayedColumns"
              [labels]="deudoresLabels"
              [dataSource]="deudoresDataSource"
              [columnNumber]="deudoresDisplayedColumns.length"
            ></app-dynamic-table>
          </div>
          <h2 class="mt-5 mb-2">Factoring con que opera</h2>
          <app-dynamic-table 
              [displayedColumns]="factoringDisplayedColumns"
              [labels]="factoringLabels"
              [dataSource]="factoringDataSource"
              [columnNumber]="factoringDisplayedColumns.length"
            ></app-dynamic-table>

            <mat-form-field appearance="outline" class="example-full-width" style="width: 100%;">
              <mat-label>Observaciones</mat-label>
              <textarea matInput placeholder="Observaciones..."></textarea>
            </mat-form-field>
      </mat-expansion-panel>

      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
            <mat-panel-title> <mat-chip appereance="outline" class="color-tertiary status-chip mr-3">II</mat-chip>Información Financiera</mat-panel-title>
            <!-- <mat-panel-description> This is a summary of the content </mat-panel-description> -->
          </mat-expansion-panel-header>
             <div class="row">
              <div class="col-5">
                <h2 class="mt-5 mb-2">Índices Último Balance</h2>
                <app-dynamic-table 
                  [displayedColumns]="UltimoBDisplayedColumns"
                  [labels]="UltimoBLabels"
                  [dataSource]="UltimoBDataSource"
                  [columnNumber]="UltimoBDisplayedColumns.length"
                ></app-dynamic-table>
              </div>
              <div class="col-4">
                <h2 class="mt-5 mb-2">Venta Promedio Mensual M$</h2>
                <app-dynamic-table 
                  [displayedColumns]="VPMisplayedColumns"
                  [labels]="VPMLabels"
                  [dataSource]="VPMDataSource"
                  [columnNumber]="VPMisplayedColumns.length"
                ></app-dynamic-table>
              </div>
              <div class="col-3">
                <h2 class="mt-5 mb-2">Morosidades Protestos</h2>
                <app-dynamic-table 
                  [displayedColumns]="MPisplayedColumns"
                  [labels]="MPLabels"
                  [dataSource]="MPDataSource"
                  [columnNumber]="MPisplayedColumns.length"
                ></app-dynamic-table>
              </div>
            </div>
            <h2 class="mt-5 mb-2">Año 2024</h2>
            <app-dynamic-table 
                  [displayedColumns]="FinAnioisplayedColumns"
                  [labels]="FinAnioLabels"
                  [dataSource]="FinAnioDataSource"
                  [columnNumber]="FinAnioisplayedColumns.length"
                ></app-dynamic-table>
      </mat-expansion-panel>

      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
            <mat-panel-title>Carga Financiera</mat-panel-title>
            <!-- <mat-panel-description> This is a summary of the content </mat-panel-description> -->
        </mat-expansion-panel-header>

        <mat-form-field disabled="true" appearance="outline" class="example-full-width mx-2" style="width: 100%;">
          <mat-label>Nombre del Cliente</mat-label>
          <input matInput placeholder="Ex. Pizza" value="LIQUIDACION FORZPA AUSTRAL TRADING SPA">
        </mat-form-field>

        <div class="info-card-container d-flex mt-2">
          <div class="card-row d-flex mt-2">
              <mat-form-field disabled="true" appearance="outline" class="example-full-width mx-2">
                <mat-label>Fecha Curse</mat-label>
                <input matInput [matDatepicker]="picker">
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              <mat-form-field appearance="outline" class="mx-2">
                <mat-label>Institución</mat-label>
                <input matInput placeholder="Ex. Pizza" value="1-9">
              </mat-form-field>
              <mat-form-field appearance="outline" class="mx-2">
                <mat-label>Tipo de Crédito</mat-label>
                <input matInput placeholder="Ex. Pizza" value="">
              </mat-form-field>
              <mat-form-field appearance="outline" class="mx-2">
                <mat-label>Crédito Original M$</mat-label>
                <input matInput placeholder="Ex. Pizza" value="">
              </mat-form-field>
              <mat-form-field disabled="true" appearance="outline" class="mx-2">
                <mat-label>Deuda Actual M$</mat-label>
                <input matInput placeholder="Ex. Pizza" value="3">
              </mat-form-field>
              <mat-form-field appearance="outline" class="example-full-width mx-2">
                <mat-label>Cuota M$</mat-label>
                <input matInput placeholder="Ex. Pizza" value="100.000">
              </mat-form-field>
              <mat-form-field appearance="outline" class="example-full-width mx-2">
                <mat-label>N Cuotas por pagar</mat-label>
                <input matInput placeholder="Ex. Pizza" value="">
              </mat-form-field>
              <mat-form-field appearance="outline" class="example-full-width mx-2">
                <mat-label>N Cuotas Morosas</mat-label>
                <input matInput placeholder="Ex. Pizza" value="">
              </mat-form-field>
          </div>
      </div>

      <button mat-stroked-button color="primary" class="mt-2" style="font-size: 20px;">-</button>
      <button mat-flat-button color="primary" class="mt-2 ml-2" style="font-size: 20px;">+</button>

      <div class="info-card-container mt-3">
        <div class="info-card">
          <h4>Total Crédito Original</h4>
          <p>0</p>
        </div>
        <div class="info-card">
            <h4>Total Deuda Actual</h4>
            <p>0</p>
          </div>
        <div class="info-card">
          <h4>Total Cuota</h4>
          <p>0</p>
        </div>
        <div class="info-card">
          <h4>Total Cuotas por pagar</h4>
          <p>0</p>
        </div>
        <div class="info-card">
          <h4>Total Cuotas Morosas</h4>
          <p>0</p>
        </div>

      </div>

      <div class="info-container">
        <p><strong>Fecha de curse:</strong> Es la fecha en que fue tomado el crédito con el banco.</p>

        <p><strong>Tipo de Crédito:</strong> Aquí se debe decir si es un crédito en cuotas (mensuales o anuales), crédito a plazo fijo, Boleta de garantía o carta de crédito, línea de capital de trabajo, Leasing, etc.</p>

        <p><strong>Crédito Original:</strong> Es el monto por el cual fue tomado el crédito.</p>

        <p><strong>Deuda Actual:</strong> Es lo que queda por pagar del crédito.</p>

        <p><strong>Cuota:</strong> Es lo que paga mensual o anualmente según el tipo de crédito.</p>

        <p><strong>Cuotas Faltantes:</strong> Son las cuotas que quedan por pagar.</p>

        <p><strong>Vencimiento:</strong> Es la fecha en que el crédito se termina, es cuando se paga la última cuota.</p>

        <p><strong>Garantías Vigentes:</strong> Se debe indicar si el crédito fue tomado solo con avales o con alguna prenda o hipoteca, de ser una de las dos últimas indicar el valor en M$.</p>

      </div>
      </mat-expansion-panel>
    </mat-accordion>

    <button type="button" mat-flat-button color="primary" (click)="fileInput.click()" class="mt-3">Subir Archivo</button>
    <button *ngIf="pdfUrl" type="button" mat-button color="primary" class="ml-3" (click)="seePDF()"><mat-icon>visibility</mat-icon>Ver Archivo</button>
    <input #fileInput hidden type="file" (change)="onFileSelected($event)" accept="application/pdf">

</div>